import { render, staticRenderFns } from "./addressBook.vue?vue&type=template&id=24af5610&scoped=true"
import script from "./addressBook.vue?vue&type=script&lang=js"
export * from "./addressBook.vue?vue&type=script&lang=js"
import style0 from "./addressBook.vue?vue&type=style&index=0&id=24af5610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af5610",
  null
  
)

export default component.exports